const BundleDataTypes = {
  pass1b_06: [
    {
      type: 'phenotype',
      phase: 'pass1b-06',
      title: 'Phenotype',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Endurance Training',
      description:
        'Phenotypic data from young adult rats (6-month old) that performed the endurance exercise training.',
      object_zipfile: 'pass1b-06/bundles/motrpac_pass1b-06_phenotype.zip',
      object_zipfile_size: '617.78 KB',
    },
    {
      type: 'transcriptomics',
      phase: 'pass1b-06',
      title: 'Transcriptomics',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Endurance Training',
      description:
        'Analyses, sample-level metadata, QC, and quantitative results across tissues for RNA-seq.',
      object_zipfile: 'pass1b-06/bundles/motrpac_pass1b-06_transcriptomics.zip',
      object_zipfile_size: '540.44 MB',
    },
    {
      type: 'metabolomics-targeted',
      phase: 'pass1b-06',
      title: 'Metabolomics-targeted',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Endurance Training',
      description:
        'Analyses, sample-level metadata, QC, and quantitative results across tissues for metabolomics-targeted assays.',
      object_zipfile:
        'pass1b-06/bundles/motrpac_pass1b-06_metabolomics-targeted.zip',
      object_zipfile_size: '27.58 MB',
    },
    {
      type: 'metabolomics-untargeted',
      phase: 'pass1b-06',
      title: 'Metabolomics-untargeted',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Endurance Training',
      description:
        'Analyses, sample-level metadata, QC, and quantitative results across tissues for metabolomics-untargeted assays.',
      object_zipfile:
        'pass1b-06/bundles/motrpac_pass1b-06_metabolomics-untargeted.zip',
      object_zipfile_size: '272.42 MB',
    },
    {
      type: 'proteomics-untargeted',
      phase: 'pass1b-06',
      title: 'Proteomics-untargeted',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Endurance Training',
      description:
        'Analyses, sample-level metadata, QC, and quantitative results across tissues for the Acetyl Proteomics, Global Proteomics, Phosphoproteomics, and Protein Ubiquitination.',
      object_zipfile:
        'pass1b-06/bundles/motrpac_pass1b-06_proteomics-untargeted.zip',
      object_zipfile_size: '975.70 MB',
    },
    {
      type: 'proteomics-targeted',
      phase: 'pass1b-06',
      title: 'Proteomics-targeted',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Endurance Training',
      description:
        'Analyses, sample-level metadata, QC, and quantitative results across tissues for immunoassay.',
      object_zipfile:
        'pass1b-06/bundles/motrpac_pass1b-06_proteomics-targeted.zip',
      object_zipfile_size: '12.06 MB',
    },
    {
      type: 'tissue-gastrocnemius',
      phase: 'pass1b-06',
      title: 'Gastrocnemius',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Endurance Training',
      description:
        'Analyses, sample-level metadata, QC, and quantitative results across omes/assays, except epigenomics (e.g. ATAC-seq, RRBS), for gastrocnemius.',
      object_zipfile: 'pass1b-06/bundles/motrpac_pass1b-06_gastrocnemius.zip',
      object_zipfile_size: '151.41 MB',
    },
    {
      type: 'tissue-heart',
      phase: 'pass1b-06',
      title: 'Heart',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Endurance Training',
      description:
        'Analyses, sample-level metadata, QC, and quantitative results across omes/assays, except epigenomics (e.g. ATAC-seq, RRBS), for heart.',
      object_zipfile: 'pass1b-06/bundles/motrpac_pass1b-06_heart.zip',
      object_zipfile_size: '187.387 MB',
    },
    {
      type: 'tissue-liver',
      phase: 'pass1b-06',
      title: 'Liver',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Endurance Training',
      description:
        'Analyses, sample-level metadata, QC and quantitative results across omes/assays, except epigenomics (e.g. ATAC-seq, RRBS), for liver.',
      object_zipfile: 'pass1b-06/bundles/motrpac_pass1b-06_liver.zip',
      object_zipfile_size: '214.00 MB',
    },
    {
      type: 'tissue-lung',
      phase: 'pass1b-06',
      title: 'Lung',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Endurance Training',
      description:
        'Analyses, sample-level metadata, QC, and quantitative results across omes/assays, except epigenomics (e.g. ATAC-seq, RRBS), for lung.',
      object_zipfile: 'pass1b-06/bundles/motrpac_pass1b-06_lung.zip',
      object_zipfile_size: '242.33 MB',
    },
    {
      type: 'tissue-kidney',
      phase: 'pass1b-06',
      title: 'Kidney',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Endurance Training',
      description:
        'Analyses, sample-level metadata, QC, and quantitative results across omes/assays, except epigenomics (e.g. ATAC-seq, RRBS), for kidney.',
      object_zipfile: 'pass1b-06/bundles/motrpac_pass1b-06_kidney.zip',
      object_zipfile_size: '179.62 MB',
    },
    {
      type: 'tissue-brown-adipose',
      phase: 'pass1b-06',
      title: 'Brown adipose',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Endurance Training',
      description:
        'Analyses, sample-level metadata, QC, and quantitative results across omes/assays, except epigenomics (e.g. ATAC-seq, RRBS), for brown adipose.',
      object_zipfile: 'pass1b-06/bundles/motrpac_pass1b-06_brown-adipose.zip',
      object_zipfile_size: '57.99 MB',
    },
    {
      type: 'tissue-white-adipose',
      phase: 'pass1b-06',
      title: 'White adipose',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Endurance Training',
      description:
        'Analyses, sample-level metadata, QC, and quantitative results across omes/assays, except epigenomics (e.g. ATAC-seq, RRBS), for white adipose.',
      object_zipfile: 'pass1b-06/bundles/motrpac_pass1b-06_white-adipose.zip',
      object_zipfile_size: '189.69 MB',
    },
    {
      type: 'tissue-blood-rna',
      phase: 'pass1b-06',
      title: 'Blood RNA',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Endurance Training',
      description:
        'Analyses, sample-level metadata, QC, and quantitative results in RNA-seq for blood RNA.',
      object_zipfile: 'pass1b-06/bundles/motrpac_pass1b-06_blood.zip',
      object_zipfile_size: '17.93 MB',
    },
    {
      type: 'tissue-plasma',
      phase: 'pass1b-06',
      title: 'Plasma',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Endurance Training',
      description:
        'Analyses, sample-level metadata, QC, and quantitative results in targeted/untargeted metabolomics and immunoassay for plasma.',
      object_zipfile: 'pass1b-06/bundles/motrpac_pass1b-06_plasma.zip',
      object_zipfile_size: '53.58 MB',
    },
    {
      type: 'misc-analysis-resources',
      phase: 'pass1b-06',
      title: 'Miscellaneous analysis resources',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Endurance Training',
      description:
        'Miscellaneous resource files for R objects used in the data analysis of young adult rats performing endurance exercise training.',
      object_zipfile:
        'pass1b-06/bundles/motrpac_pass1b-06_misc-analysis-resources.zip',
      object_zipfile_size: '166.93 MB',
    },
  ],
  pass1a_06: [
    {
      type: 'phenotype',
      phase: 'pass1a-06',
      title: 'Phenotype',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Acute Exercise',
      description:
        'Phenotypic data from young adult rats (6-month old) that performed the acute exercise training.',
      object_zipfile: 'pass1a-06/bundles/motrpac_pass1a-06_phenotype.zip',
      object_zipfile_size: '339.51 KB',
    },
    {
      type: 'transcriptomics',
      phase: 'pass1a-06',
      title: 'Transcriptomics',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Acute Exercise',
      description:
        'Sample-level metadata, QC, and quantitative results across tissues for RNA-seq.',
      object_zipfile: 'pass1a-06/bundles/motrpac_pass1a-06_transcriptomics.zip',
      object_zipfile_size: '381.07 MB',
    },
    {
      type: 'proteomics-untargeted',
      phase: 'human-precovid-sed-adu',
      title: 'Proteomics-untargeted',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Acute Exercise',
      description:
        'Sample-level metadata, QC, and quantitative results across tissues for Acetyl Proteomics, Global Proteomics, Phosphoproteomics.',
      object_zipfile:
        'pass1a-06/bundles/motrpac_pass1a-06_proteomics-untargeted.zip',
      object_zipfile_size: '2.19 GB',
    },
    {
      type: 'metabolomics-targeted',
      phase: 'human-precovid-sed-adu',
      title: 'Metabolomics-targeted',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Acute Exercise',
      description:
        'Sample-level metadata, QC, and quantitative results across tissues for metabolomics-targeted assays.',
      object_zipfile:
        'pass1a-06/bundles/motrpac_pass1a-06_metabolomics-targeted.zip',
      object_zipfile_size: '1 MB',
    },
    {
      type: 'metabolomics-untargeted',
      phase: 'human-precovid-sed-adu',
      title: 'Metabolomics-untargeted',
      species: 'Rat',
      participant_type: 'Young Adult',
      intervention: 'Acute Exercise',
      description:
        'Sample-level metadata, QC, and quantitative results across tissues for metabolomics-untargeted assays.',
      object_zipfile:
        'pass1a-06/bundles/motrpac_pass1a-06_metabolomics-untargeted.zip',
      object_zipfile_size: '207.7 MB',
    },
  ],
  human_sed_adu: [
    {
      type: 'phenotype',
      phase: 'human-precovid-sed-adu',
      title: 'Phenotype',
      species: 'Human',
      participant_type: 'Adult',
      intervention: 'Sedentary',
      study_group: 'Pre-COVID',
      description:
        'Phenotypic data from human sedentary adults performing acute exercise prior to COVID-19.',
      object_zipfile:
        'human-precovid/bundles/motrpac_human-precovid-sed-adu_phenotype.zip',
      object_zipfile_size: '89.44 MB',
    },
    {
      type: 'transcriptomics',
      phase: 'human-precovid-sed-adu',
      title: 'Transcriptomics',
      species: 'Human',
      participant_type: 'Adult',
      intervention: 'Sedentary',
      study_group: 'Pre-COVID',
      description:
        'Differential analysis, metadata, QC normalized data across human tissues for RNA-seq.',
      object_zipfile:
        'analysis/bundles/motrpac_human-precovid-sed-adu_transcriptomics.zip',
      object_zipfile_size: '321.97 MB',
    },
    {
      type: 'proteomics',
      phase: 'human-precovid-sed-adu',
      title: 'Proteomics',
      species: 'Human',
      participant_type: 'Adult',
      intervention: 'Sedentary',
      study_group: 'Pre-COVID',
      description:
        'Differential analysis, metadata, QC normalized data across human tissues for Global Proteomics, Phosphoproteomics, and OLink.',
      object_zipfile:
        'analysis/bundles/motrpac_human-precovid-sed-adu_proteomics.zip',
      object_zipfile_size: '117.91 MB',
    },
    {
      type: 'metabolomics-targeted',
      phase: 'human-precovid-sed-adu',
      title: 'Metabolomics-targeted',
      species: 'Human',
      participant_type: 'Adult',
      intervention: 'Sedentary',
      study_group: 'Pre-COVID',
      description:
        'Differential analysis, metadata, QC normalized data across human tissues for metabolomics-targeted assays.',
      object_zipfile:
        'analysis/bundles/motrpac_human-precovid-sed-adu_metabolomics-targeted.zip',
      object_zipfile_size: '13.82 MB',
    },
    {
      type: 'metabolomics-untargeted',
      phase: 'human-precovid-sed-adu',
      title: 'Metabolomics-untargeted',
      species: 'Human',
      participant_type: 'Adult',
      intervention: 'Sedentary',
      study_group: 'Pre-COVID',
      description:
        'Differential analysis, metadata, QC normalized data across human tissues for metabolomics-untargeted assays.',
      object_zipfile:
        'analysis/bundles/motrpac_human-precovid-sed-adu_metabolomics-untargeted.zip',
      object_zipfile_size: '217.87 MB',
    },
    {
      type: 'epigenomics',
      phase: 'human-precovid-sed-adu',
      title: 'Epigenomics',
      species: 'Human',
      participant_type: 'Adult',
      intervention: 'Sedentary',
      study_group: 'Pre-COVID',
      description:
        'Differential analysis, metadata, QC normalized data across human tissues for ATAC-seq and Methylcap-seq assays.',
      object_zipfile:
        'ganalysis/bundles/motrpac_human-precovid-sed-adu_epigenomics.zip',
      object_zipfile_size: '3.11 GB',
    },
  ],
};

export default BundleDataTypes;
